module.exports = __webpack_public_path__ + "static/gem_of_seeing-594826f9c870cd643ca40e686876e5bd.jpeg";